<div class="container_slider--home">
  <div class="banner_horizontal--slider">
    <a [routerLink]="['/product', 'desuraida-amon-devil-man']">
      <img ngSrc="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/banner_desuraida_web_oneoff.jpg" alt="slider" eager width="1200" height="1000" class="d-none d-md-block" />
      <img ngSrc="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/banner_desuraida_web_oneoff.jpg" alt="slider" eager width="215" height="104" class="d-md-none" />
    </a>
  </div>
  <!-- <div class="banner_horizontal--slider">
    <a [routerLink]="['/category', 'vag']">
      <img ngSrc="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/banne_vags.webp" alt="slider" eager width="1200"
        height="1000" class="d-none d-md-block" />
      <img ngSrc="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/banne_vags.webp" alt="slider" eager width="215"
        height="104" class="d-md-none" />
    </a>
  </div>
  <div class="banner_horizontal--slider">
    <a href="https://link.clip.mx/etoyrepublic/catalogo" target="_blank">
      <img ngSrc="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/banner_meses.webp" alt="slider" eager width="1200"
        height="1000" class="d-none d-md-block" />
      <img ngSrc="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/banner_meses_mobile.webp" alt="slider" eager
        width="215" height="104" class="d-md-none" />
    </a>
  </div>
  <div class="banner_horizontal--slider">
    <a [routerLink]="['/product', 'hedgehogs-season-series']">
      <img ngSrc="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/hedgehog.webp" alt="slider" eager width="1200"
        height="1000" class="d-none d-md-block" />
      <img ngSrc="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/hedgehog_mobile.webp" alt="slider" eager width="215"
        height="104" class="d-md-none" />
    </a>
  </div>
  <div class="banner_horizontal--slider">
    <a [routerLink]="['/product', 'crybaby-x-powerpuff-girls-']">
      <img ngSrc="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/chias_poderosas.webp" alt="slider" eager width="1200"
        height="1000" class="d-none d-md-block" />
      <img ngSrc="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/chias_poderosas_mobile.webp" alt="slider" eager
        width="215" height="104" class="d-md-none" />
    </a>
  </div> -->
  <!-- <fa-stack class="d-none d-md-block down" size="2x">
    <fa-icon [icon]="['far', 'circle']" stackItemSize="2x" animation="bounce" class="circle"></fa-icon>
    <fa-icon [icon]="['far', 'down']" [inverse]="true" stackItemSize="1x" animation="bounce"></fa-icon>
  </fa-stack> -->
</div>
